import React, { useEffect, useState } from 'react'
import {
    Card,
    CardBody,
    Col,
    Container,
    Label,
    Row
} from "reactstrap";
import Breadcrumbs from 'components/Common/Breadcrumb';
import { getPromotion } from 'helpers/UAM/promotion.helper';
import { formatDateString } from 'common/utility';
import { useNavigate } from 'react-router-dom';

const ViewPromotion = () => {
    document.title = "View Promocode | DMS"

    const [promotion, setPromotion] = useState({})
    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    const navigate = useNavigate()

    useEffect(() => {
        getPromotion({ id: decodedId })
            .then(responseFromAPI => {
                if (responseFromAPI.status && responseFromAPI.code == 200) {
                    let responseData = responseFromAPI.data;
                    responseData.startDate = formatDateString(
                        responseData.startDate
                    );
                    responseData.endDate = formatDateString(
                        responseData.endDate
                    );
                    setPromotion(responseData)
                }
            })
            .catch(error => { })
    }, [])

    const handleCancel = () => {
        navigate(-1)
    }

    return (
        <div className='page-content'>
            <Breadcrumbs title="Promotions" breadcrumbItem="View Promotion" />
            <Container fluid>
                <Card>
                    <CardBody>
                        <Row className="vertical-scroll">
                            <Col xs="12" md="6">
                                <div className="mb-3">
                                    <Label className="form-label" style={{ fontWeight: 600 }}>Promotion Code</Label>
                                    <p>{promotion.promotionCode}</p>
                                </div>
                            </Col>

                            <Col xs="12" md="6">
                                <div className="mb-3">
                                    <Label className="form-label" style={{ fontWeight: 600 }}>Discount</Label>
                                    <p>{promotion.discount}%</p>
                                </div>
                            </Col>

                            <Col xs="12" md="6">
                                <div className="mb-3">
                                    <Label className="form-label" style={{ fontWeight: 600 }}>Start Date</Label>
                                    <p>{promotion.startDate}</p>
                                </div>
                            </Col>

                            <Col xs="12" md="6">
                                <div className="mb-3">
                                    <Label className="form-label" style={{ fontWeight: 600 }}>Expiry Date</Label>
                                    <p>{promotion.endDate}</p>
                                </div>
                            </Col>

                            <Col xs="12" md="6">
                                <div className="mb-3">
                                    <Label className="form-label" style={{ fontWeight: 600 }}>Description</Label>
                                    <p>{promotion.description}</p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={handleCancel}
                                >
                                    Back
                                </button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

            </Container>
        </div>
    )
}

export default ViewPromotion
